import React, {Component} from 'react';
import {
  Redirect,
} from "react-router-dom";

import ApiService from './ApiService';

import TempleList from './TempleList';

/**
 * List of user temples.
 *
 * @class      UserTempleList (name)
 */
class UserTempleList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      temples: [],
    };

    ApiService.loadJSON(__API_URL__ + `/user/temples`)
      .then(templeData => {
        this.setState({
          temples: templeData,
        });
      });
  }

  render() {

    let temples = this.state.temples;

    // renders temple list page with user parameter and temple available passed
    return (
      <div>
        {
          temples && temples.length > 1 &&
            <TempleList userLoggedIn temples={temples} />
        }

        {
          temples && temples.length === 1 &&
            <Redirect to={`/user/temple/${temples[0].id}`} />
        }
      </div>
    );
  }
}

export default UserTempleList;



// WEBPACK FOOTER //
// ./js/UserTempleList.js